import { HotelInfo } from "@website/accommodation-ui/hotel-card-new";
import { CityDataType } from "@website/accommodation-ui/hotel-search";
import { CMSSeoContentData } from "@website/website-ui/services/seo-contents/cms-types";
import { MarketingBannerItemDataType } from "@website/widget/banner-slide";

export type VillaLocationResponseType = {
  room_availability: {
    availability: number;
    from: string;
    min_stay: number;
    room_id: number;
    to: string;
    total_local_price_off: number;
    total_price: number;
    base_price: number;
    base_price_off: number;
    discount: number;
    instant: boolean;
  };
  room_data: {
    seo?: {
      noIndex: boolean;
    };
    amenities: [
      {
        icon: string;
        id: number;
        title: string;
      }
    ];
    badges: [
      { color: string; description: string; title: string; type: string }
    ];
    gallery: [
      {
        id: number;
        name: string;
        title: string;
        order_no: number;
      }
    ];
    categories: Array<{
      id: number;
      name: string;
    }>;
    capacity: number;
    description: string;
    extra_capacity: number;
    id: number;
    image: string;
    is_active: boolean;
    property?: {
      rating: { avg: number; count: number };
      shortAddress?: string;
      amenities: [
        {
          icon: string;
          id: number;
          title: string;
        }
      ];
      areas: [
        {
          id: number;
          slug: string;
          title: string;
        }
      ];
      cancellation_rules: string;
      check_in_time: string;
      check_out_time: string;
      city: {
        id: number;
        slug: string;
        title: string;
      };
      description: string;
      gallery: [
        {
          id: number;
          name: string;
          room_id: number;
          title: string;
          type: string;
        }
      ];
      id: number;
      image: string;
      slug: string;
      isActive: boolean;
      location: {
        latitude: number;
        longitude: number;
      };
      priority: number;
      rules_allowed: [
        {
          id: number;
          is_active: boolean;
          title: string;
        }
      ];
      rules_disallowed: [
        {
          id: number;
          is_active: boolean;
          title: string;
        }
      ];
      state: {
        id: number;
        slug: string;
        title: string;
      };
      title: string;
      type: string;
      village: {
        id: number;
        slug: string;
        title: string;
      };
    };
    property_id: number;
    search_weight: number;
    title: string;
  };
};

export type CityPagePropertiesType = {
  seoData?: CMSSeoContentData;
  locationData?: CityDataType;
  villagesData?: Array<
    HotelInfo & {
      page: number;
      total: number;
    }
  >;
  hasError?: boolean;
  smallBanners?: Array<MarketingBannerItemDataType>;
  staticBanners?: Array<MarketingBannerItemDataType>;
};

export type VillaSearchTextType = {
  geo: Array<{
    entity: string;
    id: number;
    location: {
      latitude: number;
      longitude: number;
    };
    slug: string;
    title: string;
  }>;

  properties: Array<{
    amenity_ids: Array<number>;
    areas_ids: Array<number>;
    city_id: number;
    country_id: number;
    description: string;
    id: number;
    latitude: number;
    longitude: number;
    priority: number;
    rules_allowed: Array<number>;
    rules_disallowed: Array<number>;
    slug: string;
    state_id: number;
    status: boolean;
    title: string;
    type: string;
    url_en: string;
    url_fa: string;
    village_id: number;
  }>;
};
export const reasonsSchema = {
  telesales_not_found: "عدم یافتن اقامتگاه مناسب",
  telesales_price_change: "تغییر قیمت",
  telesales_incident: "مشکلات فنی",
  telesales_complexities: "پیچیدگی رزرو آنلاین",
  telesales_help: "نیاز به راهنمایی کارشناس",
  telesales_do_not_trust: "عدم اعتماد به رزرو آنلاین",
  telesales_special_request: "درخواست‌های ویژه"
};
